import { CLASSES } from '../../utils/constants';

function toggleOverflow(isOpen) {
  if (isOpen) {
    document.body.classList.add(CLASSES.OVERFLOW_HIDDEN);
  } else {
    document.body.classList.remove(CLASSES.OVERFLOW_HIDDEN);
  }
}

const initNavigation = () => {
  
  const desktopNavigation = document.querySelector('[data-navigation-desktop]');
  const mobileNavigation = document.querySelector('[data-nav-mobile-menu]');
  const toggleMobileNavigation = document.querySelectorAll('[data-nav-mobile-toggle]');

  const subMenuToggle = document.querySelectorAll('[data-submenu-toggle]');
  const subMenuBack = document.querySelectorAll('[data-submenu-back]');

  const subMenus = document.querySelectorAll('[data-submenu]');

  const searchPopup = document.querySelector('[data-search-container]');

  let isOpen = false;

  toggleMobileNavigation.forEach((btn) => {

    btn.addEventListener('click', () => {
      mobileNavigation.classList.toggle('-translate-x-full');

      if (!mobileNavigation.hasAttribute('open')) {
        mobileNavigation.setAttribute('open', true);
        isOpen = true;
      } else {
        mobileNavigation.removeAttribute('open');    
        isOpen = false;
      }

      // if (!searchPopup.hasAttribute('open')) {
      //   toggleOverflow(isOpen);
      // }

      toggleOverflow(isOpen);

      subMenus.forEach((submenu) => {
        submenu.classList.add('hidden');
      });

    });

  });

  desktopNavigation.addEventListener('mouseenter', () => {
    desktopNavigation.setAttribute('open', true);
  });

  desktopNavigation.addEventListener('mouseleave', () => {
    desktopNavigation.removeAttribute('open');  
  });

  subMenuToggle.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const submenu = toggle.nextElementSibling;

      submenu.classList.toggle('hidden');
      toggle.setAttribute('aria-expanded', submenu.classList.contains('hidden') ? 'false' : 'true');
    });

  });

  subMenuBack.forEach((back) => {
    
    back.addEventListener('click', () => {
      const submenu = back.parentElement;
      const parentMenu = submenu.parentElement;
      parentMenu.setAttribute('aria-expanded', 'true');
      parentMenu.classList.toggle('hidden');
      
    });
    
  });

};
  
export default initNavigation;